import BattlePassBlock from "./battlepass";

const BattlePass = () => {
  return (
    <div style={{ marginTop: 500 }}>
      <BattlePassBlock />
    </div>
  );
};

export default BattlePass;
